import React from "react";
import { ToastContainer } from "react-toastify";
import UpdateBanner from "../../components/Settings/Banner/UpdateBanner";

export const UpdateBannerPage = () => {
  return (
    <div className="main-content">
      <div className="page-content">
        <div className="container-fluid">
          <ToastContainer
            position="top-right"
            autoClose={5000}
            hideProgressBar={false}
          />
          <UpdateBanner />
        </div>
      </div>
    </div>
  );
};
